import { McpSetupPage } from '../../McpSetupPage';

/**
 * Thin re-export that lets the existing /mcp setup page live inside both
 * Company Settings and User Settings. Keeps a single source of truth for
 * the walk-through content.
 */
export const McpSetupTab = McpSetupPage;
